import { gql } from '@apollo/client';

export const UNCHECK_FIRST_ACCESSS = gql`
  mutation uncheckFirstAccess {
    uncheckFirstAccess {
      success
      vetProfile {
        id
        firstAccess
      }
    }
  }
`;

export const VERIFY_INFO = gql`
  mutation verifyInfo {
    verifyInfo {
      success
      vetProfile {
        id
        verifiedInfo
      }
    }
  }
`;

export const EDIT_VET_PROFILE = gql`
  mutation editVetProfile($vetProfile: VetProfileInput!) {
    editVetProfile(vetProfile: $vetProfile) {
      success
      vetProfile {
        id
        profilePic
        phoneNumber
        petcoUserId
        emailNotifications
        textNotifications
        automaticallyAddRunsToCalendar
      }
    }
  }
`;

export const ADD_INSURANCE = gql`
  mutation addInsurance($insurance: InsuranceInput!) {
    addInsurance(insurance: $insurance) {
      success
      vetProfile {
        id
        insurances {
          id
          document
          expirationDate
          policyNumber
        }
      }
      error {
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const EDIT_INSURANCE = gql`
  mutation editInsurance($id: ID!, $insurance: InsuranceInput!) {
    editInsurance(id: $id, insurance: $insurance) {
      success
      vetProfile {
        id
        insurances {
          id
          document
          expirationDate
          policyNumber
        }
      }
      error {
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const ADD_LICENSE = gql`
  mutation addLicense($license: LicenseInput!) {
    addLicense(license: $license) {
      success
      vetProfile {
        id
        licenses {
          id
          document
          expirationDate
          number
          stateCode
        }
      }
      error {
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const EDIT_LICENSE = gql`
  mutation editLicense($id: ID!, $license: LicenseInput!) {
    editLicense(id: $id, license: $license) {
      success
      vetProfile {
        id
        licenses {
          id
          document
          expirationDate
          number
          stateCode
        }
      }
      error {
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const ADD_REGISTRATION = gql`
  mutation addRegistration($registration: RegistrationInput!) {
    addRegistration(registration: $registration) {
      success
      vetProfile {
        id
        deaRegistrations {
          id
          document
          expirationDate
          number
          stateCode
        }
      }
      error {
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const EDIT_REGISTRATION = gql`
  mutation editRegistration($id: ID!, $registration: RegistrationInput!) {
    editRegistration(id: $id, registration: $registration) {
      success
      vetProfile {
        id
        deaRegistrations {
          id
          document
          expirationDate
          number
          stateCode
        }
      }
      error {
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const S3_SIGNED_URL = gql`
  mutation signedUrl($files: [FileSignatureInputType]!) {
    generateUploadSignatures(files: $files) {
      presignedPosts
      error {
        __typename
      }
    }
  }
`;

const ONBOARDING_VET_PROFILE_FRAGMENT = gql`
  fragment CoreOnboardingVetProfileFields on OnboardingVetProfileType {
    firstName
    lastName
    email
    phoneNumber
    shouldEmailNotifications
    shouldTextNotifications
    address1
    address2
    state
    city
    zipcode
    preferences
    referralSource {
      id
      name
    }
    status
  }
`;

export const CREATE_ONBOARDING_VET_PROFILE = gql`
  ${ONBOARDING_VET_PROFILE_FRAGMENT}
  mutation onboardingVetProfileCreate($vetProfile: CreateOnboardingVetProfileInput!) {
    onboardingVetProfileCreate(input: $vetProfile) {
      onboardingVetProfile {
        uid
        ...CoreOnboardingVetProfileFields
      }
    }
  }
`;

export const UPDATE_ONBOARDING_VET_PROFILE = gql`
  ${ONBOARDING_VET_PROFILE_FRAGMENT}
  mutation onboardingVetProfileUpdate($uid: UUID!, $vetProfile: UpdateOnboardingVetProfileInput!) {
    onboardingVetProfileUpdate(uid: $uid, updatedProfile: $vetProfile) {
      onboardingVetProfile {
        ...CoreOnboardingVetProfileFields
      }
    }
  }
`;

const DOCUMENTS_FRAGMENT = gql`
 fragment CoreDocumentsFields on OnboardingDocumentType {
    uid
    document
    documentType
 }
`;

export const ADD_ONBOARDING_LICENSE = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation onboardingLicenseDocumentCreate($document: OnboardingDocumentInputType!) {
    onboardingLicenseCreate(document: $document) {
      document {
        ...CoreDocumentsFields
      }
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const ADD_ONBOARDING_REGISTRATION = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation onboardingRegistrationDocumentCreate($document: OnboardingDocumentInputType!) {
    onboardingRegistrationCreate(document: $document) {
      document {
        ...CoreDocumentsFields
      }
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const ADD_ONBOARDING_INSURANCE = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation onboardingInsuranceDocumentCreate($document: OnboardingDocumentInputType!) {
    onboardingInsuranceCreate(document: $document) {
      document {
        ...CoreDocumentsFields
      }
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const ONBOARDING_VET_PROFILE_RECOVERY = gql`
  mutation onboardingVetProfileRecover($email: String!) {
    onboardingVetProfileRecover(email: $email) {
      success
    }
  }
`;
